import React, { MouseEvent } from "react";
import { CarProductIntroFormValues } from "./interfaces";

import { useTexts } from "Components/TextContext";
import { ThemedButton } from "Components/Themes/components/ThemedButton";
import { buttonTrackId } from "Utils/analytics";
import { useFormikContext } from "formik";
import { VehicleInputType } from "../FormElements/interfaces";
import { resetVehicle } from "./utils/resetVehicle";

export const InputTypeButton = (): React.ReactElement => {
  const { getText } = useTexts();
  const formProps = useFormikContext<CarProductIntroFormValues>();
  const { values, setFieldValue } = formProps;

  const isManual = values.vehicleInputType === VehicleInputType.MANUAL;

  const onClickHandler = (event: MouseEvent): void => {
    event.preventDefault();
    setFieldValue(
      "vehicleInputType",
      isManual ? VehicleInputType.LICENSE_PLATE : VehicleInputType.MANUAL,
    );
    resetVehicle(formProps);
  };

  const text = isManual
    ? getText("carform.button.searchforyourcar")
    : getText("carform.button.doesnothaveregnumber");

  return (
    <ThemedButton
      type="button"
      variant="text"
      iconRight="arrow-right"
      trackId={buttonTrackId("vehicle-input-type")}
      data-trackid={buttonTrackId("vehicle-input-type")}
      onClick={onClickHandler}
    >
      {text}
    </ThemedButton>
  );
};
